import * as React from "react";

const SortUpArrow: React.FC = () => {
    return (
        <svg width="11" height="15" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M4.745.81.307 5.127a1.02 1.02 0 0 0 0 1.459 1.09 1.09 0 0 0 1.499 0l2.636-2.55v9.432c0 .575.47 1.032 1.06 1.032.59 0 1.06-.457 1.06-1.032V4.037l2.62 2.55a1.09 1.09 0 0 0 1.5 0c.211-.207.318-.472.318-.737 0-.266-.106-.531-.318-.737L6.259.81A1.094 1.094 0 0 0 5.502.5c-.288 0-.56.103-.757.31z"
                fill="#006AE3"
                fill-rule="nonzero"
            />
        </svg>
    );
};

export default React.memo(SortUpArrow);
